<template>
    <div class="wizard-footer">
        <div class="separator"></div>

        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <div class="">
                    <button type="button" class="btn btn-outline-secondary" @click="postBackward($event)">Indietro
                    </button>
                </div>
                <div class="d-flex align-items-center">
                    <button type="button" class="d-none d-lg-block btn btn-outline-primary mr-2" v-if="inputs_are_changed" @click="sendRefreshEvent">
                        Reimposta mappa
                    </button>
                    <button type="button" class="d-block d-lg-none mr-2 btn btn-outline-primary" v-if="inputs_are_changed" @click="sendRefreshEvent">
                        Reimposta
                    </button>
                    <button type="button" class="btn btn-primary" v-if="this.display_next_button && this.step !== 'alt' && !inputs_are_changed"
                            @click="postForward($event)">Avanti
                    </button>
                    <button type="button" class="btn btn-primary d-none d-lg-block" v-if="this.step === 'alt'" @click="procedi($event)">
                        Procedi con la valutazione
                    </button>
                    <button type="button" class="btn btn-primary d-block d-lg-none" v-if="this.step === 'alt'" @click="procedi($event)">
                        Procedi
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {getParameterByName} from "@/helpers/helper";
import Button from "@/Jetstream/Button";

export default {
    components: {Button},

    props: ['step', 'display_next_button', 'wizard_data', 'step_0_address', 'user', 'inputs_are_changed'],

    data() {
        return {
            property_id: getParameterByName('property_id'),
            current_property_id: localStorage.getItem('current_property_id')
        }
    },

    computed: {
        showRefresh: function () {
            return this.display_next_button && this.step === 1;
        }
    },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        sendRefreshEvent() {
            this.$emit('refresh-address');
        },

        postBackward(e) {
            let step = this.step
            if (this.step === 'alt') {
                step = 2
            }
            if (step === 1) {
                window.location.href = 'https://cashouse.com'

                return
            }

            if (step === 7 && this.isAgency()) {
                this.$inertia.visit('' + (step - 2))

                return
            }

            this.$inertia.visit('' + (step - 1))
        },


        postForward(e) {
            e.preventDefault();

            var self = this;

            if (this.step === 0) {
                this.$inertia.visit('/wizard/customer/1?address=' + this.step_0_address)

                return
            }

            if (this.step === 5) {
                const formData = new FormData()

                this.wizard_data.files.forEach(file => {
                    if (file instanceof File) {
                        formData.append("files[]", file, file.name)
                    } else {
                        let details = JSON.stringify(file)

                        formData.append("existing_files[]", details)
                    }
                })

                formData.append("property_id", this.current_property_id)

                const config = {
                    headers: {"Content-Type": "multipart/form-data;"}
                }

                axios.post('/wizard/customer/post/step/5', formData, config)
                    .then(response => {
                        localStorage.setItem('current_property', JSON.stringify(response.data.property))

                        if (this.isAgency()) {
                            self.$inertia.visit('' + (this.step + 2))

                            return
                        }

                        self.$inertia.visit('' + (this.step + 1))
                    })
                    .catch(error => {
                        console.log(error)
                    })
            } else {
                axios.post('/wizard/customer/post/step/' + this.step,{
                    ...this.wizard_data,
                    property_id: this.current_property_id
                })
                .then(response => {
                    if (this.step === 1) {
                        if (response.data.type === 'success') {
                            if (response.data.has_municipality === 'no') {
                                localStorage.setItem('current_property_id', response.data.property.id)
                                localStorage.setItem('current_property', JSON.stringify(response.data.property))

                                this.$inertia.visit('2alt')

                                return
                            }

                        } else {
                            this.$toast.error(response.data.message)
                        }

                        localStorage.setItem('current_property_id', response.data.property.id)
                        localStorage.setItem('current_property', JSON.stringify(response.data.property))
                    }

                    if (this.step === 7) {
                        $('#content-step-7').addClass('d-none');
                        $('.loader-container').removeClass('d-none');
                        const self = this
                        setTimeout(function () {
                            localStorage.setItem('current_property', JSON.stringify(response.data.property))

                            axios.post('send-mail',{
                                user_email: response.data.property.user_email,
                            })
                            .catch(error => {
                                console.log(error)
                            })

                            self.$inertia.visit('' + (self.step + 1))
                        }, 3000);
                    }

                    localStorage.setItem('current_property', JSON.stringify(response.data.property))

                    self.$inertia.visit('' + (self.step + 1))

                })
                .catch(error => {
                    console.log(error)
                });
            }
        },
        procedi(e) {
            this.$inertia.visit('2')
        }
    }
}
</script>
